export const ShowcaseDisplayAreaEnum = {
  TOP_HOMEPAGE: 1,
  MIDDLE_HOMEPAGE: 2,
  BOTTOM_HOMEPAGE: 3,
  PRODUCT_PAGE: 4,
  SHOWCASE_MENU: 5,
  CART_SHOWCASE_MENU: 6,
};
